// @flow

import EmptyState from "app/components/analytics/shared/EmptyState";
import Row from "./Row";

type Test = {
  id: string,
  name: string,
  scope: string,
  location: string,
  average_duration: string,
  reliability: string,
  url: string,
};

type Props = {
  tests: Array<Test>,
};

const Table = ({ tests }: Props) => {
  if (tests.length === 0) {
    return (
      <EmptyState
        emoji="🤖"
        heading="No tests have been run"
        subheading="We haven’t received any test executions. Create a run and check back soon."
      />
    );
  }

  return (
    <section>
      <ul className="ta-card__container">
        <li
          aria-hidden={true}
          className="ta-card__container--heading col-12 mb1 px3"
        >
          <div className="main-section" style={{ width: "100%" }}>
            Description
          </div>
          <div className="right-align" style={{ width: "100px" }}>
            Reliability
          </div>
          <div className="right-align" style={{ width: "128px" }}>
            Average duration
          </div>
        </li>

        {tests.map((test: Test) => (
          <Row key={test.id} test={test} />
        ))}
      </ul>
    </section>
  );
};

export default Table;
